export class UtilLarguraTela {

    static checarLarguraTela() : boolean{
        return window.screen.width > 768;
      }

}